import {
  Flame, Route, Truck, GraduationCap, Lock, Users, Send,
  Crown, Briefcase, Music, ClipboardCheck, Megaphone, Heart,
  Handshake, HeartHandshake, HelpingHand,
} from "lucide-react";

// Maps backend icon strings to lucide-react components.
export const ICONS = {
  flame: Flame,
  route: Route,
  truck: Truck,
  "graduation-cap": GraduationCap,
  lock: Lock,
  users: Users,
  send: Send,
  crown: Crown,
  briefcase: Briefcase,
  music: Music,
  "clipboard-check": ClipboardCheck,
  megaphone: Megaphone,
  heart: Heart,
  handshake: Handshake,
  hands: HelpingHand,
  "heart-handshake": HeartHandshake,
};

export const getIcon = (name) => ICONS[name] || Flame;
